import type { GatewayPrincipalsDocumentView } from '@/types';

export const ALL_RESTRICTIONS_VALUE = '*';

export const GATEWAY_PROTOCOL_OPTIONS = [
  'openai_responses',
  'anthropic_messages',
] as const;

export type RestrictionMode = 'all' | 'restricted';

export interface RestrictionFieldState {
  mode: RestrictionMode;
  selected: string[];
}

export function normalizeUniqueValues(values: string[]) {
  return values
    .map((value) => value.trim())
    .filter(Boolean)
    .filter((value, index, array) => array.indexOf(value) === index);
}

export function buildRestrictionFieldState(
  values?: string[],
): RestrictionFieldState {
  if (!values || values.length === 0 || isAllRestrictions(values)) {
    return {
      mode: 'all',
      selected: [],
    };
  }

  return {
    mode: 'restricted',
    selected: normalizeUniqueValues(
      values.filter((value) => value !== ALL_RESTRICTIONS_VALUE),
    ),
  };
}

export function serializeRestrictionField(
  field: RestrictionFieldState,
): string[] {
  if (field.mode === 'all') {
    return [ALL_RESTRICTIONS_VALUE];
  }
  return normalizeUniqueValues(field.selected);
}

export function collectGatewayModelOptions(
  document: GatewayPrincipalsDocumentView | null,
  currentValues: string[] = [],
) {
  const values = [
    ...(document?.principals.flatMap((item) => item.allowedModels) || []),
    ...currentValues,
  ];

  return normalizeUniqueValues(
    values.filter((value) => value !== ALL_RESTRICTIONS_VALUE),
  );
}

export function isAllRestrictions(values?: string[]) {
  return !values || values.length === 0 || values.includes(ALL_RESTRICTIONS_VALUE);
}
